export default __webpack_public_path__ + "static/media/img3.5f2145e5.png";